export const DDC_ICON_PREFIX = 'ddc-icon-';



// WEBPACK FOOTER //
// ./src/global-constants.js